<div class="container">
	<label class="text-center text-tertiary fw-semibold w-100 export-title my-3">
		Climatologia (mm) - {{ periodoTitulo }}
	</label>

	<div
		*ngIf="carregando; else mapa"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false" />
	</div>

	<ng-template #mapa>
		<div
			id="mapa-legenda"
			class="row"
			*ngIf="interpolacao; else nenhumResultado">
			<div class="col-12">
				<div class="mb-3 map-wrapper">
					<div class="mapa-coordenadas-overlay"></div>

					<seira-mapa-interpolacao
						[mapaId]="mapaId"
						[mapaNome]="'Climatologia'"
						[imageOpacity]="0.8"
						[interpolacao]="interpolacao"
						[carregando]="carregando"
						[valores]="climatologias"
						(mapaEmitter)="onMapReady($event)">
					</seira-mapa-interpolacao>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #nenhumResultado>
		<div class="row">
			<div class="col-12">
				<seira-sem-dados />
			</div>
		</div>
	</ng-template>

	<seira-card-info aditionalClasses="my-2" [texto]="descricaoRelatorio" />
</div>
